import type { FunctionComponent } from 'react';
import { useCallback, useMemo } from 'react';

import { DevToolsToggle } from '../DevToolsToggle';

const RGB_FILTER_CLASSNAME = 'rgb-filter';

export const RgbModeToggle: FunctionComponent = () => {
    const isRgbModeActive = useMemo(
        () => document.documentElement.classList.contains(RGB_FILTER_CLASSNAME),
        [],
    );

    const toggleRgbMode = useCallback(
        (isActive: boolean) =>
            document.documentElement.classList.toggle(RGB_FILTER_CLASSNAME, isActive),
        [],
    );

    return <DevToolsToggle active={isRgbModeActive} label="RGB mode" onToggle={toggleRgbMode} />;
};
